import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import EntityListPage from "./pages/EntityListPage";
import EntityDetailPage from "./pages/EntityDetailPage";
import CalendarPage from "./pages/CalendarPage";
import AkilChatPage from "./pages/ai/AkilChatPage";
import AkilEvrakScanPage from "./pages/ai/AkilEvrakScanPage";
import AkilBasvuruMetniPage from "./pages/ai/AkilBasvuruMetniPage";
import AkilMesajTaslagiPage from "./pages/ai/AkilMesajTaslagiPage";
import AkilGunlukBrifingPage from "./pages/ai/AkilGunlukBrifingPage";
import AkilLogPage from "./pages/ai/AkilLogPage";
import AkilMerkezPage from "./pages/ai/AkilMerkezPage";
import EpostaMerkezPage from "./pages/yeni/EpostaMerkezPage";
import TahkimMerkezPage from "./pages/yeni/TahkimMerkezPage";
import IcraMerkezPage from "./pages/yeni/IcraMerkezPage";
import ZamanAsimiPage from "./pages/yeni/ZamanAsimiPage";
import OdemeRaporlariPage from "./pages/yeni/OdemeRaporlariPage";
import KasaHesaplarPage from "./pages/yeni/KasaHesaplarPage";
import YetkiSablonlariPage from "./pages/yeni/YetkiSablonlariPage";
import FiloCanliDestekPage from "./pages/filo/FiloCanliDestekPage";
import AraciBildirimGonderPage from "./pages/yeni/AraciBildirimGonderPage";
import AraciMerkezPage from "./pages/yeni/AraciMerkezPage";
import WhatsAppMerkezPage from "./pages/yeni/WhatsAppMerkezPage";
import MuvekkilMerkezPage from "./pages/yeni/MuvekkilMerkezPage";
import MuvekkilPanelAyarPage from "./pages/yeni/MuvekkilPanelAyarPage";
import FiloMerkezPage from "./pages/yeni/FiloMerkezPage";
import RayicIstihbaratPage from "./pages/yeni/RayicIstihbaratPage";
import EkspertizHasarMerkezPage from "./pages/yeni/EkspertizHasarMerkezPage";
import EkspertizHasarMerkezLayout from "./pages/yeni/EkspertizHasarMerkezLayout";
import HasarSatinAlmaPage from "./pages/yeni/HasarSatinAlmaPage";
import DegerKaybiGelismisPage from "./pages/yeni/DegerKaybiGelismisPage";
import DkOnHesapPage from "./pages/yeni/DkOnHesapPage";
import AktueryaMerkezPage from "./pages/yeni/AktueryaMerkezPage";
import YatarBedeliMerkezPage from "./pages/yeni/YatarBedeliMerkezPage";
import KusurSorgulamaPage from "./pages/yeni/KusurSorgulamaPage";
import PartsouqOemKarsilastirmaPage from "./pages/yeni/PartsouqOemKarsilastirmaPage";
import BilusParcaMerkezPage from "./pages/yeni/BilusParcaMerkezPage";
import SupremeOpsPage from "./pages/yeni/SupremeOpsPage";
import FinansKarZararPage from "./pages/yeni/FinansKarZararPage";
import DkKalibrasyonPage from "./pages/yeni/DkKalibrasyonPage";
import PazarlikMerkezPage from "./pages/yeni/PazarlikMerkezPage";
import DosyaSaglikPanosuPage from "./pages/yeni/DosyaSaglikPanosuPage";
import SiteStatsAyarPage from "./pages/yeni/SiteStatsAyarPage";
import SiteYonetimiMerkezLayout from "./pages/yeni/SiteYonetimiMerkezLayout";
import SiteYonetimiOzetTab from "./pages/yeni/SiteYonetimiOzetTab";
import SistemGunluguMerkezLayout from "./pages/yeni/SistemGunluguMerkezLayout";
import SistemGunluguOzetTab from "./pages/yeni/SistemGunluguOzetTab";
import EmbeddedEntityList from "./components/EmbeddedEntityList";
import IletisimMerkezLayout from "./pages/yeni/IletisimMerkezLayout";
import DegerKaybiMerkezLayout, { DkKayitlarTab } from "./pages/yeni/DegerKaybiMerkezLayout";
import RayicParcaMerkezLayout from "./pages/yeni/RayicParcaMerkezLayout";
import FinansMerkezLayout, { FinansDefterlerTab } from "./pages/yeni/FinansMerkezLayout";
import DosyaOperasyonMerkezLayout from "./pages/yeni/DosyaOperasyonMerkezLayout";
import { LegacyHubRedirect } from "./components/MerkezHubShell";


function App() {
    return (
        <div className="App dark">
            <AuthProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route
                            path="/"
                            element={
                                <ProtectedRoute>
                                    <Layout />
                                </ProtectedRoute>
                            }
                        >
                            <Route index element={<Dashboard />} />
                            <Route path="takvim" element={<CalendarPage />} />
                            <Route path="ai/merkez" element={<AkilMerkezPage />} />
                            <Route path="ai/sohbet" element={<AkilChatPage />} />
                            <Route
                                path="ai/resimden-muvekkil"
                                element={<AkilEvrakScanPage mode="muvekkil" />}
                            />
                            <Route
                                path="ai/resimden-dosya"
                                element={<AkilEvrakScanPage mode="sigorta" />}
                            />
                            <Route path="ai/basvuru-metni" element={<AkilBasvuruMetniPage />} />
                            <Route path="ai/mesaj-taslagi" element={<AkilMesajTaslagiPage />} />
                            <Route path="ai/gunluk-brifing" element={<AkilGunlukBrifingPage />} />
                            <Route path="ai/islem-loglari" element={<AkilLogPage />} />
                            <Route path="yeni/zaman-asimi" element={<LegacyHubRedirect to="/yeni/dosya-operasyon-merkezi/zaman-asimi" />} />
                            <Route path="yeni/odeme-raporlari" element={<LegacyHubRedirect to="/yeni/finans-merkezi/odeme-raporlari" />} />
                            <Route path="yeni/kasa-hesaplar" element={<LegacyHubRedirect to="/yeni/finans-merkezi/kasa" />} />
                            
                            {/* === Birlesik Merkezler === */}
                            <Route path="yeni/iletisim-merkezi" element={<IletisimMerkezLayout />}>
                                <Route index element={<Navigate to="whatsapp" replace />} />
                                <Route path="whatsapp" element={<WhatsAppMerkezPage />} />
                                <Route path="eposta" element={<EpostaMerkezPage />} />
                                <Route path="muvekkil" element={<MuvekkilMerkezPage />} />
                                <Route path="ayar" element={<MuvekkilPanelAyarPage />} />
                            </Route>
                            <Route path="yeni/deger-kaybi-merkezi" element={<DegerKaybiMerkezLayout />}>
                                <Route index element={<Navigate to="gelismis" replace />} />
                                <Route path="gelismis" element={<DegerKaybiGelismisPage />} />
                                <Route path="on-hesap" element={<DkOnHesapPage />} />
                                <Route path="kalibrasyon" element={<DkKalibrasyonPage />} />
                                <Route path="kayitlar" element={<DkKayitlarTab />} />
                            </Route>
                            <Route path="yeni/rayic-parca-merkezi" element={<RayicParcaMerkezLayout />}>
                                <Route index element={<Navigate to="rayic" replace />} />
                                <Route path="rayic" element={<RayicIstihbaratPage />} />
                                <Route path="partsouq" element={<PartsouqOemKarsilastirmaPage />} />
                                <Route path="bilus" element={<BilusParcaMerkezPage />} />
                                <Route path="hasar" element={<EkspertizHasarMerkezLayout />}>
                                    <Route index element={<Navigate to="uzman" replace />} />
                                    <Route path="uzman" element={<EkspertizHasarMerkezPage />} />
                                    <Route path="satin-alma" element={<HasarSatinAlmaPage />} />
                                </Route>
                            </Route>
                            <Route path="yeni/finans-merkezi" element={<FinansMerkezLayout />}>
                                <Route index element={<Navigate to="kasa" replace />} />
                                <Route path="kasa" element={<KasaHesaplarPage />} />
                                <Route path="odeme-raporlari" element={<OdemeRaporlariPage />} />
                                <Route path="kar-zarar" element={<FinansKarZararPage />} />
                                <Route path="defterler" element={<FinansDefterlerTab />} />
                            </Route>
                            <Route path="yeni/dosya-operasyon-merkezi" element={<DosyaOperasyonMerkezLayout />}>
                                <Route index element={<Navigate to="supreme" replace />} />
                                <Route path="supreme" element={<SupremeOpsPage />} />
                                <Route path="zaman-asimi" element={<ZamanAsimiPage />} />
                                <Route path="saglik" element={<DosyaSaglikPanosuPage />} />
                                <Route path="pazarlik" element={<PazarlikMerkezPage />} />
                            </Route>

                            <Route path="yeni/site-yonetimi" element={<SiteYonetimiMerkezLayout />}>
                                <Route index element={<Navigate to="ozet" replace />} />
                                <Route path="ozet" element={<SiteYonetimiOzetTab />} />
                                <Route path="slider" element={<EmbeddedEntityList entityKey="slider" />} />
                                <Route path="haberler" element={<EmbeddedEntityList entityKey="haberler" />} />
                                <Route path="istatistikler" element={<SiteStatsAyarPage embedded />} />
                                <Route path="basvuru-formlari" element={<EmbeddedEntityList entityKey="basvuru-formlari" />} />
                                <Route path="pwa" element={<EmbeddedEntityList entityKey="pwa-kullanicilari" />} />
                            </Route>

                            <Route path="yeni/sistem-gunlugu" element={<SistemGunluguMerkezLayout />}>
                                <Route index element={<Navigate to="ozet" replace />} />
                                <Route path="ozet" element={<SistemGunluguOzetTab />} />
                                <Route path="audit" element={<EmbeddedEntityList entityKey="audit-loglari" />} />
                                <Route path="whatsapp" element={<EmbeddedEntityList entityKey="whatsapp-loglari" />} />
                                <Route path="ai-gorevler" element={<EmbeddedEntityList entityKey="ai-gorevler" />} />
                                <Route path="ai-oneriler" element={<EmbeddedEntityList entityKey="ai-oneryler" />} />
                            </Route>

                            <Route path="yeni/yetki-sablonlari" element={<YetkiSablonlariPage />} />
                            <Route path="filo/canli-destek" element={<FiloCanliDestekPage />} />
                            <Route path="yeni/araci-bildirim-gonder" element={<LegacyHubRedirect to="/yeni/araci-merkezi?tab=gonder" />} />
                            <Route path="yeni/araci-merkezi" element={<AraciMerkezPage />} />
                            <Route path="yeni/whatsapp-merkezi" element={<LegacyHubRedirect to="/yeni/iletisim-merkezi/whatsapp" />} />
                            <Route path="yeni/muvekkil-merkezi" element={<LegacyHubRedirect to="/yeni/iletisim-merkezi/muvekkil" />} />
                            <Route path="yeni/muvekkil-panel-ayar" element={<LegacyHubRedirect to="/yeni/iletisim-merkezi/ayar" />} />
                            <Route path="yeni/filo-merkezi" element={<FiloMerkezPage />} />
                            <Route path="yeni/rayic-istihbarat" element={<LegacyHubRedirect to="/yeni/rayic-parca-merkezi/rayic" />} />
                            <Route path="yeni/partsouq-oem-karsilastirma" element={<LegacyHubRedirect to="/yeni/rayic-parca-merkezi/partsouq" />} />
                            <Route path="yeni/bilus-parca-merkezi" element={<LegacyHubRedirect to="/yeni/rayic-parca-merkezi/bilus" />} />
                            <Route path="yeni/ekspertiz-hasar" element={<LegacyHubRedirect to="/yeni/rayic-parca-merkezi/hasar/uzman" />} />
                            <Route path="yeni/deger-kaybi-gelismis" element={<LegacyHubRedirect to="/yeni/deger-kaybi-merkezi/gelismis" />} />
                            <Route path="yeni/deger-kaybi-on-hesap" element={<LegacyHubRedirect to="/yeni/deger-kaybi-merkezi/on-hesap" />} />
                            <Route path="yeni/aktuerya-merkezi" element={<AktueryaMerkezPage />} />
                            <Route path="yeni/yatar-bedeli-merkezi" element={<YatarBedeliMerkezPage />} />
                            <Route path="yeni/kusur-sorgulama" element={<KusurSorgulamaPage />} />
                            <Route path="yeni/eposta-merkezi" element={<LegacyHubRedirect to="/yeni/iletisim-merkezi/eposta" />} />
                            <Route path="yeni/tahkim-merkezi" element={<TahkimMerkezPage />} />
                            <Route path="yeni/icra-merkezi" element={<IcraMerkezPage />} />
                            <Route path="yeni/supreme-ops" element={<LegacyHubRedirect to="/yeni/dosya-operasyon-merkezi/supreme" />} />
                            <Route path="yeni/finans-kar-zarar" element={<LegacyHubRedirect to="/yeni/finans-merkezi/kar-zarar" />} />
                            <Route path="yeni/dk-kalibrasyon" element={<LegacyHubRedirect to="/yeni/deger-kaybi-merkezi/kalibrasyon" />} />
                            <Route path="yeni/pazarlik-merkezi" element={<LegacyHubRedirect to="/yeni/dosya-operasyon-merkezi/pazarlik" />} />
                            <Route path="yeni/dosya-saglik-panosu" element={<LegacyHubRedirect to="/yeni/dosya-operasyon-merkezi/saglik" />} />
                            <Route path="yeni/site-istatistikleri" element={<LegacyHubRedirect to="/yeni/site-yonetimi/istatistikler" />} />
                            <Route path="e/:entityKey" element={<EntityListPage />} />
                            <Route
                                path="e/:entityKey/:id"
                                element={<EntityDetailPage />}
                            />
                        </Route>
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
